import { IDB_syncParamsReportStatusFlows, IDB_reportStatusFlow } from '../IDB/IDB.dexie'
import { Sync_standardSync, type Sync_Params } from '../Sync/Sync.standardSync'
import { Serv_client } from '../Serv/Serv.client'
import type { ReportStatusFlow } from '../../../shared/domain/reportStatusFlow/types.no-deps'

export function Rpts_statusFlowSync() {
    return Sync_standardSync({
        params: IDB_syncParamsReportStatusFlows(),
        sync,
        write,
        clear: () => IDB_reportStatusFlow().clear(),
    })
}

interface SyncResponse {
    reportStatusFlows: ReportStatusFlow[]
    syncTime: Date
    teams: number[]
}

async function sync(params: Sync_Params): Promise<SyncResponse> {
    const { reportStatusFlows, syncTime } = await Serv_client.syncReportStatusFlows(params.lastSyncTime)
    return { reportStatusFlows, syncTime, teams: params.teams }
}

async function write({ reportStatusFlows }: SyncResponse) {
    if (reportStatusFlows.length > 0) {
        await IDB_reportStatusFlow().bulkPut(reportStatusFlows)
    }
}
